import { Component, inject } from '@angular/core';
import { FwButtonComponent, FwLayoutContextComponent } from '@flywheel-io/vision';

import { AuthService } from '../auth.service';

@Component({
  host: { 'test-id': 'session-timeout-error' },
  selector: 'session-timeout-error',
  imports: [FwLayoutContextComponent, FwButtonComponent],
  template: `
    <fw-layout-context
      description="You have been logged out due to inactivity."
      icon="warning-circle"
      iconColor="danger"
      title="Session Timeout"
    >
      <fw-button leftIcon="rotate-refresh" size="large" variant="outline" (click)="auth.loginAfterSessionTimeout()">
        Login
      </fw-button>
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        width: 100vw;
        height: 100vh;
        background: var(--page-light);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    `,
  ],
})
export class SessionTimeoutErrorComponent {
  protected auth = inject(AuthService);
}
